export default __webpack_public_path__ + "static/media/036-nine.0c07aa94.svg";